module.exports = __webpack_public_path__ + "static/media/emmaandgrace.7ea66001.png";